import {
  JOB_STATUS_QUEUED,
  JOB_STATUS_RUNNING,
  JOB_STATUS_COMPLETE,
  JOB_STATUS_ERROR,
  JOB_STATUS_ABANDONED,
  JOB_STATUS_CANCELED,
  JOB_STATUS_TERMINATED,
  JOB_STEP_STATUS_QUEUED,
  JOB_STEP_STATUS_DEQUEUED,
  JOB_STEP_STATUS_RUNNING,
  JOB_STEP_STATUS_COMPLETE,
  JOB_STEP_STATUS_ERROR,
  JOB_STEP_STATUS_TERMINATED,
  JOB_STEP_STATUS_SKIPPED,
  JOB_STEP_STATUS_ABANDONED,
  JOB_STEP_STATUS_CANCELED
} from './constants';

//MsgBox
export const SuccessfulWorkflowCreation = '{0} created successfully';
export const SuccessfulWorkflowUpdate = '{0} has been updated';
export const SuccessfulWorkflowDeactivation = '{0} has been deactivated';

export const DeleteGroupTitle = 'Are you sure?';
export const DeleteGroupBody = 'Are you sure you want to delete this group? None of the users will be deactivated.';
export const DeleteGroupBodyWithChildren = 'Deleting this group will also delete any child groups contained in it.';
export const DeleteGroupWithChildPrimaryButtonText = 'Delete this group and its descendants';
export const DeleteGroupSecondaryButtonText = 'Do not delete';
export const DeleteGroupPrimaryButtonText = 'Delete';

export const SaveGroupWithChildrenTitle = 'Group Permissions Change';
export const SaveGroupWithChildrenBody =
  'Please note that removing permissions from this group may not affect its descendants. If permissions were inherited from this group, they will revert to their prior state. Any permissions you may have individually granted to a group will not be removed.';
export const SaveGroupWithChildrenPrimaryBtn = 'Update changes';
export const SaveGroupWithChildrenSecondaryBtn = 'Cancel changes';

export const AddGroupToAdminTitle = 'Sorry';
export const AddGroupToAdminBody = 'You cannot add child groups to Administrators';

export const DeactivateUserTitle = 'Deactivate User?';
export const DeactivateUserBody = 'Are you sure you want to deactivate this user?';

export const ReactivateUserTitle = 'Are you sure?';
export const ReactivateUserBody = 'Are you sure you want to reactivate this user?';
export const ReactivateIndependentUserBody =
  'This user is an Independent User. Their profile may be associated with other GoFormz accounts, but you still decide what they can access in your account. Do you want to reactivate them?';

export const DeleteUserTitle = 'Delete Pending User?';
export const DeleteUserBody = 'Are you sure you want to delete {0} from your account?';

export const SuccessfulUserCreation = '{0} created successfully';
export const SuccessfulUserUpdate = '{0} has been updated';
export const SuccessfulUserDeactivation = '{0} has been deactivated';
export const SuccessfulUserReactivation = '{0} has been reactivated';
export const SuccessfulUserInviteSent = 'Invite sent to {0}';
export const SuccessfulUserPasswordResetSent = 'Password reset sent to {0}';
export const SuccessfulUserDeleted = '{0} has been deleted';

export const SuccessfulGroupCreation = '{0} created successfully';
export const SuccessfulGroupUpdate = '{0} updated successfully';
export const SuccessfulGroupDeletion = '{0} has been deleted';

export const PasswordSuccessfulUpdate = 'Password successfully updated';

//Email Status
export const EmailStatusValid = 'This email is successfully receiving messages sent from GoFormz. All good here!';
export const EmailStatusMailboxFull =
  'The mailbox associated with this email address may be full and unable to receive email messages. We suggest checking the status of this mailbox or entering a new email address.';
export const EmailStatusNoReply =
  'This email address is registered as a no_reply email and cannot accept new messages. We suggest updating to an email address that is able to receive email messages.';
export const EmailStatusMailboxNotFound =
  'The mailbox associated with this email address was not found. We recommend checking the status of this mailbox or entering a new email address.';
export const EmailStatusNoDnsPart1 = 'Our records show that this email address domain (';
export const EmailStatusNoDnsPart2 =
  ') does not have valid DNS records. We suggest checking that this email is entered correctly and is able to receive email messages.';
export const EmailStatusDroppedSpam =
  "Our records show that emails sent from GoFormz to the email address entered are arriving in the Spam Folder. We recommend saving no-reply@goformz.com as a contact to this email address's mailbox to prevent further delivery to the Spam Folder.";
export const EmailStatusDroppedUnsubscribed1 =
  'Our records show that this email address has unsubscribed from messages sent by no-reply@goformz.com making the address unable to receive mail from GoFormz. To resubscribe this email address, please go to ';
export const EmailStatusDroppedUnsubscribedLink = 'https://blog.goformz.com/';
export const EmailStatusDroppedUnsubscribed2 = ' click the Sign Up for Newsletter button and enter the unsubscribed email address.';
export const EmailStatusDroppedBounced =
  'The last email sent to this email address was unable to be delivered. We suggest double checking that this email is entered correctly and is able to receive email messages.';
export const EmailStatusInvaildSyntax =
  'Oops. This email address is not formatted correctly. Make sure to conform to standard email address format (user@company.com) and remove any spaces or extra characters or punctuation';

//Validation
export const DidYouMean = 'Did you mean';
export const EmailRequired = 'Email is required.';
export const FieldIsMandatory = 'You must complete this field.';

//Errors
export const ErrorTitle = 'Error';
export const SearchResultsError = 'Error retrieving search results.';
export const ChangingPasswordError = 'Error changing password.  Please try again later.';
export const ChangingPasswordErrorPreviousPassword = 'You cannot use one of your last 5 passwords.';
export const GetGroupsDropdownError = 'Error getting all groups. Please contact support.';
export const GetUserDetailsError = 'Error getting user info. Please contact support.';
export const CreateUserError = 'Error creating a user. Please contact support.';
export const GetUsersError = 'Error getting users. Please contact support.';
export const SavingUserError = 'Error saving user. Please contact support.';
export const DeactivatingUserError = 'Error deactivating user. Please contact support.';
export const ReactivatingUserError = 'Error reactivating user. Please contact support.';
export const ResendInviteError = 'Error resending invite. Please contact support.';
export const PasswordResetError = 'Error sending password reset. Please contact support.';
export const DeleteUserError = 'Error deleting user. Please contact support.';
export const LoggingOutDeviceError = 'Failed to logout of device. Please refresh the page and contact support for more details.';

export const GettingTemplateFoldersError = 'Error getting template folders. Please contact support.';
export const CreateGroupError = 'Error creating group. Please contact support.';
export const AddGroupError = 'Error while trying to create a group. Please contact support.';
export const GetGroupsListError = 'Error getting groups. Please contact support.';
export const GetGroupDetailsError = 'Error getting group info. Please contact support.';
export const SavingGroupError = 'Error saving group. Please contact support.';
export const DeletingGroupError = 'Error deleting group. Please contact support.';

export const SearchResultsTitle = 'Search Users and Groups';
export const Users = 'Users';
export const EmailAddress = 'Email Address';
export const Groups = 'Groups';
export const Members = 'Members';
export const Parent = 'Parent';
export const SearchResultsHint = 'New Keyboaard Shortcuts: / activates search field';

export const CreateWorkflowError = 'Error creating a workflow. Please contact support.';
export const GetWorkflowsError = 'Error getting workflows. Please contact support.';
export const GetWorkflowError = 'Error getting workflow. Please contact support.';
export const GetJobError = 'Error getting workflow job. Please contact support.';
export const RerunJobError = 'Error re-running workflow job. Please contact support.';
export const SavingWorkflowError = 'Error saving workflow. Please contact support.';
export const Workflows = 'Workflows';

export const SavingTemplateError = 'Error saving template. Please contact support.';
export const PublishingTemplateError = 'Error publishing template. Please contact support.';

// Tooltips
export const parentPermission = 'This is a parent permission';
export const selfDeactivation = 'Unable to disable your own account';
export const adminDeactivation = 'Unable to disable admin accounts';

export const GetJargonizedJobStatus = (status) => {
  let displayValue;
  switch (status) {
    case JOB_STATUS_QUEUED:
      displayValue = 'Queued';
      break;
    case JOB_STATUS_RUNNING:
      displayValue = 'Running';
      break;
    case JOB_STATUS_COMPLETE:
      displayValue = 'Complete';
      break;
    case JOB_STATUS_ERROR:
      displayValue = 'Failed';
      break;
    case JOB_STATUS_TERMINATED:
      displayValue = 'Terminated';
      break;
    case JOB_STATUS_ABANDONED:
      displayValue = 'Abandoned';
      break;
    case JOB_STATUS_CANCELED:
      displayValue = 'Canceled';
      break;
    default:
      displayValue = status;
      break;
  }

  return displayValue;
};

export const GetJargonizedJobStepStatus = (status) => {
  let displayValue;
  switch (status) {
    case JOB_STEP_STATUS_QUEUED:
      displayValue = 'Queued';
      break;
    case JOB_STEP_STATUS_DEQUEUED:
      displayValue = 'N/A';
      break;
    case JOB_STEP_STATUS_RUNNING:
      displayValue = 'Running';
      break;
    case JOB_STEP_STATUS_COMPLETE:
      displayValue = 'Complete';
      break;
    case JOB_STEP_STATUS_ERROR:
      displayValue = 'Failed';
      break;
    case JOB_STEP_STATUS_TERMINATED:
      displayValue = 'Ended by step conditions';
      break;
    case JOB_STEP_STATUS_SKIPPED:
      displayValue = 'Skipped';
      break;
    case JOB_STEP_STATUS_ABANDONED:
      displayValue = 'Abandoned';
      break;
    case JOB_STEP_STATUS_CANCELED:
      displayValue = 'Terminated by user';
      break;
    default:
      displayValue = status;
      break;
  }

  return displayValue;
};
